import { fetchInventoryConverts, selectInventoryConvert, resetCurrentInventoryConvert } from '../../actions/inventoryConverts_actions';
import { connect } from 'react-redux';

import InventoryConverts from '../../components/Inventories/inventoryConverts'

function mapStateToProps(state) {
    return {
        inventoryConverts: state.inventoryConverts.all,
        isLoading: state.inventoryConverts.isLoading,
        error: state.inventoryConverts.error,
        currentInventoryConvert: state.inventoryConverts.currentInventoryConvert,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { fetchInventoryConverts, selectInventoryConvert, resetCurrentInventoryConvert })(InventoryConverts);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryConverts.jsx